var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top-notification text-center text-white font-sm py-1",
      class: _vm.typeClass,
    },
    [
      _c(
        "span",
        { staticClass: "mr-2" },
        [
          _vm.icon !== false
            ? _c("icon", { attrs: { name: _vm.iconToUse } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }